const LOAD_DATA_MASTER_LANGUAGE_SKILLS           = 'LOAD_DATA_MASTER_LANGUAGE_SKILLS'
const LOAD_DATA_MASTER_LANGUAGE_SKILLS_SUCCESS   = 'LOAD_DATA_MASTER_LANGUAGE_SKILLS_SUCCESS'
const LOAD_DATA_MASTER_LANGUAGE_SKILLS_FAILED    = 'LOAD_DATA_MASTER_LANGUAGE_SKILLS_FAILED'
const UNMOUNT_DATA_MASTER_LANGUAGE_SKILLS        = 'UNMOUNT_DATA_MASTER_LANGUAGE_SKILLS'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const masterLanguageSkillsReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_LANGUAGE_SKILLS:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_MASTER_LANGUAGE_SKILLS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_MASTER_LANGUAGE_SKILLS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_MASTER_LANGUAGE_SKILLS:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default masterLanguageSkillsReducer;